import { store } from 'v3/data/store';
import { IInstallment, IInstallmentsItem, IPixQRCodePayment } from 'v3/data/store/installments/types';
import { installmentsSlice } from '.';

export const setInstallmentsList = (item: IInstallmentsItem) => {
  store.dispatch(installmentsSlice.actions.setInstallmentsList(item));
};

export const setInstallmentsToPay = (items: IInstallment[]) => {
  store.dispatch(installmentsSlice.actions.setInstallmentsToPay(items));
};

export const setTotalToPay = (totalToPay: number) => {
  store.dispatch(installmentsSlice.actions.setTotalToPay(totalToPay));
};

export const setIntallmentContractingKey = (contractingKey: string) => {
  store.dispatch(installmentsSlice.actions.setIntallmentContractingKey(contractingKey));
};

export const setPixQRCodePayment = (pixQRCodePayment: IPixQRCodePayment) => {
  store.dispatch(installmentsSlice.actions.setPixQRCodePayment(pixQRCodePayment));
};
